import { toast } from "react-toastify";

/**
 * Generic confirmation toast
 * @param {string} message
 * @param {object} options
 * @returns {Promise<boolean>}
 */
export const confirmToast = (
  message,
  {
    confirmText = "Continue",
    cancelText = "Cancel",
    confirmClass = "btn-danger",
    cancelClass = "btn-secondary"
  } = {}
) => {
  return new Promise((resolve) => {
    toast(
      ({ closeToast }) => (
        <div>
          <p style={{ marginBottom: 10 }}>{message}</p>
          <div className="d-flex gap-2 justify-content-end">
            <button
              className={`btn btn-sm ${cancelClass}`}
              onClick={() => {
                closeToast();
                resolve(false);
              }}
            >
              {cancelText}
            </button>
            <button
              className={`btn btn-sm ${confirmClass}`}
              onClick={() => {
                closeToast();
                resolve(true);
              }}
            >
              {confirmText}
            </button>
          </div>
        </div>
      ),
      {
        closeOnClick: false,
        closeButton: false,
        autoClose: false
      }
    );
  });
};
